import React from 'react';

import { IMessageComplete, IHistory } from '../../../hooks/Messages';
import { textPreprocessor } from './common';
import MessageWrapper from './MessageWrapper';

export interface IHistoryProps extends IHistory {
    message: IMessageComplete
    scrollToBottom: () => void
}

function History({ text, message }: IHistoryProps) {
    return (
        <MessageWrapper direction={message.direction}>
            <span>{textPreprocessor(text)}</span>
        </MessageWrapper>
    );
}

export default History;
